"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientServiceAssociateSelectInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var client_service_associates_1 = require("../../hooks/client-service-associates");
function ClientServiceAssociateSelectInput(props) {
    var onChange = props.onChange, value = props.value, disabled = props.disabled, name = props.name;
    var _a = (0, client_service_associates_1.useClientServiceAssociates)(), clientServiceAssociates = _a.data, error = _a.error;
    // Throw render error so that it is caught by any ErrorBoundary
    if (error) {
        throw error;
    }
    var options = clientServiceAssociates
        ? clientServiceAssociates.sort().map(function (user) { return ({ label: user.name, value: user.uuid }); })
        : [];
    function formatResponse(uuid) {
        var newClientServiceAssociate = (clientServiceAssociates || []).find(function (csa) { return csa.uuid === uuid; });
        return newClientServiceAssociate;
    }
    return (react_1.default.createElement(core_ui_1.AdvancedSelectInput, { name: name, placeholder: "Select a client service associate...", disabled: !clientServiceAssociates || disabled, onChange: function (uuid) { return onChange(formatResponse(uuid)); }, value: value && value.uuid, options: options }));
}
exports.ClientServiceAssociateSelectInput = ClientServiceAssociateSelectInput;
